import React from 'react';
import { getIn, useFormikContext } from 'formik';
import { Col, Form, Input, Row, Select, Typography } from 'antd';

const { Text } = Typography;

export const WEIGHT_UNITS = [
  { value: 'kg', label: 'Kilogramos' },
  { value: 'gr', label: 'Gramos' },
];

export const LENGTH_UNITS = [
  { value: 'cm', label: 'Centímetros' },
  { value: 'm', label: 'Metros' },
];

interface NumberProps {
  label: string;
  fieldName: string;
  span?: number;
}

const NumberField = ({ label, fieldName, span = 6 }: NumberProps) => {
  const { values, errors, touched, setFieldValue, setFieldTouched } =
    useFormikContext<Record<string, unknown>>();
  const error = getIn(touched, fieldName)
    ? getIn(errors, fieldName)
    : undefined;

  return (
    <Col xs={24} sm={12} lg={span}>
      <Form.Item
        label={label}
        validateStatus={error ? 'error' : undefined}
        help={error as string}
      >
        <Input
          type="number"
          min={0}
          value={(getIn(values, fieldName) as string) ?? ''}
          onChange={(event) => setFieldValue(fieldName, event.target.value)}
          onBlur={() => setFieldTouched(fieldName, true)}
        />
      </Form.Item>
    </Col>
  );
};

interface UnitProps {
  label: string;
  fieldName: string;
  options: { value: string; label: string }[];
}

const UnitField = ({ label, fieldName, options }: UnitProps) => {
  const { values, setFieldValue } = useFormikContext<Record<string, unknown>>();

  return (
    <Col xs={24} sm={12} lg={6}>
      <Form.Item label={label}>
        <Select
          options={options}
          value={getIn(values, fieldName)}
          onChange={(value) => setFieldValue(fieldName, value)}
        />
      </Form.Item>
    </Col>
  );
};

const MeasuresTab = () => (
  <Row gutter={[16, 0]}>
    <NumberField label="Cantidad de bultos" fieldName="packageQuantity" />
    <Col xs={24} lg={18} />

    <NumberField label="Peso" fieldName="weight" />
    <UnitField
      label="Unidad de peso"
      fieldName="weightUnit"
      options={WEIGHT_UNITS}
    />
    <Col xs={24} lg={12} />

    <NumberField label="Alto" fieldName="height" />
    <NumberField label="Ancho" fieldName="width" />
    <NumberField label="Profundidad" fieldName="length" />
    <UnitField
      label="Unidad de longitud"
      fieldName="lengthUnit"
      options={LENGTH_UNITS}
    />

    <Col span={24}>
      <Text type="secondary">
        El peso y las medidas son opcionales. Si cargás medidas, se necesitan 2
        como mínimo.
      </Text>
    </Col>
  </Row>
);

export default MeasuresTab;
